import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "react-bootstrap";
import { icons } from "@/utils/constants";
import { setShowCart } from "@/utils/constants/redux/sets";
import { URLS } from "@/utils/constants";
export const WithoutProductsMsj = ({ navigate, }) => {
    return (_jsxs("div", { className: "mt-3 pt-4 text-center", children: [_jsx("h1", { className: "fmc-offcanvas-title", children: "\u00A1Oh no!" }), _jsx("h1", { className: "fmc-offcanvas-title", children: "Carrito sin productos" }), _jsx(Button, { onClick: () => {
                    navigate(URLS.store);
                    setShowCart(false);
                }, className: "fmc-button mt-3 mx-3", children: _jsxs(_Fragment, { children: ["Ir a la tienda", _jsx("span", { children: _jsx("img", { src: icons.Basket2, alt: "Tienda - Flormorado Caf\u00E9", width: "20", className: "d-inline-block align-top ms-1" }) })] }) })] }));
};
